export class User {
    id: string;
    email: string;
    title: string;
    firstName: string;
    lastName: string;
    notes: string;
    commencedDate: Date;
    finishedDate?: Date;
    isActive: boolean;
    logoUrl: string;
    isAdmin: boolean;
    isLender: boolean;
    userTypeId: number;
    userTypeDescription: string;
    phoneNr: string;
}
